exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-wrapper[data-v-02912334]{padding-top:4rem!important}[data-v-02912334] div.title-slide h1{color:#f4bb40;font-family:sans-serif;width:45%;margin-left:55%;font-size:4.5vw;font-weight:400}", ""]);

// exports
